import { Box } from '@mui/material'

export function GridOverlay() {
  return (
    <>
      {/* Dark blueish overlay - layer 2 */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 2,
          pointerEvents: 'none',
          background: `
            linear-gradient(
              180deg,
              rgba(15, 23, 42, 0.75) 0%,
              rgba(30, 41, 59, 0.6) 50%,
              rgba(15, 23, 42, 0.75) 100%
            )
          `,
        }}
      />
      {/* Radial gradient mask - darker in center */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 3,
          pointerEvents: 'none',
          background: `
            radial-gradient(
              ellipse at center,
              rgba(0, 0, 0, 0.4) 0%,
              rgba(0, 0, 0, 0.2) 40%,
              transparent 70%
            )
          `,
        }}
      />
    </>
  )
}
